<template>
  <div :class="$root.productDetail ? 'messages messages-right' : 'messages'" ref="log" @click="$emit('update:show', 0)">
    <div class="spacer-top"></div>
    <transition-group name="conversation" tag="div">
      <message v-for="(message, index) in messages" :message="message" :key="-index" :focus="index === messages.length - 1" />
    </transition-group>
    <div class="spacer-bottom"></div>
  </div>
</template>

<script>
import Message from './Message.vue'
import { chat } from '../chat.js'
import { loadScript } from '../util.js'

export default {
  props: {
    msg: String
  },
  components: {
    Message
  },
  data () {
    return {
      prevMessageCount: null
    }
  },
  computed: {
    lastMessage () {
      return last(this.messages) || {}
    },
    messages () {
      return this.$root.messages
    }
  },
  methods: {
    afterScroll() {
      if (this.lastMessage.sender === 'bot' && this.prevMessageCount !== this.messages.length) {
        setTimeout(this.scrollDown, 100)
        this.prevMessageCount = this.messages.length
      }
    },
    async scrollDown () {
      // Load smoothscroll polyfill
      if (!('scrollBehavior' in document.documentElement.style)) {
        await loadScript('/unpkg/smoothscroll-polyfill@0.4.3/dist/smoothscroll.min.js').catch(console.log)
      }

      // Perfect vertical center
      const log = document.querySelector('.messages')
      const focus = document.querySelector('.message.focus')
      const logHeight = log.clientHeight
      const msgTop = focus.offsetTop
      const msgHeight = focus.clientHeight
      log.scroll({
        top: msgHeight > logHeight ? msgTop : msgTop + (msgHeight - logHeight) / 2,
        behavior: 'smooth'
      })
    },
    send(message) {
      chat.send(message)
    }
  },
  mounted() {
    this.afterScroll()

    if (!window.fetch || !String.prototype.includes) {
      loadScript('https://cdn.polyfill.io/v2/polyfill.min.js?features=default,es6,fetch,console.debug')
    }
  },
  watch: {
    messages () {
      this.afterScroll()
    }
  }
}

function last(arr) {
  return arr[arr.length - 1] || {}
}
</script>

<style>
.messages {
  position: relative;
  z-index: 1;
  padding: 0 1rem;
  color: white;
  position: fixed;
  z-index: 0;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  box-sizing: border-box;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.with-products .messages {
  -ms-overflow-style: none;
}
.with-products .messages::-webkit-scrollbar {
  display: none;
}
@media screen and (max-width: 999px) {
  .overview-show .messages {
    overflow: hidden;
  }
  .product-page {
    display: none;
  }
}
@media screen and (min-width: 1000px) and (orientation: landscape) {
  .messages-right {
    width: 400px;
    right: 0;
    left: calc(100% - 400px);
  }
  .messages {
    /* right: 350px; */
  }
  /*
  .messages {
    transform: translateX(-175px);
    transition: transform .4s;
  }
  .with-products .messages {
    transform: none;
  }
  .overview-show .messages {
    transform: translateX(-175px);
  }
  */
}
.conversation-enter-active,
.conversation-leave-active {
  transition: opacity 0.3s 0.3s, transform 0.3s 0.3s;
}
.msg-by-bot {
  transform-origin: left top;
}
.msg-by-you {
  transform-origin: right top;
}
.msg-by-you.conversation-enter-active,
.msg-by-you.conversation-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}
.conversation-enter,
.conversation-leave-to {
  opacity: 0;
  transform: scale(0.9);
}
.spacer-top {
  height: calc(50vh - 154px)
}
.spacer-bottom {
  height: 154px;
  max-height: calc(50vh - 154px);
}
@media (min-height: 1000px) {
  .spacer-bottom {
    height: calc(50vh - 154px);
  }
}
</style>
